<template>
  <div
    class="date-select"
  >
    <div class="date-select__main">
      {{selectedDate ? selectedDate : firstItem}}
      <div
        class="date-select__arrow-container"

        @click="showOptions"
        v-on:keyup.enter="showOptions"
        tabindex="0"
        aria-label="rozwiń liste"
      >
        <div class="date-select__arrow">
        </div>
      </div>
    </div>
    <div
      class="date-select__content"
      v-bind:class="{contentActive: showContent}"
    >
      <div
        class=""
        v-for="item in dateData"
        @click="()=>selectOption(item)"
        v-on:keyup.enter="()=>selectOption(item)"
        tabindex="0"
        :aria-label="'wybierz' + item"
        :key="item"
      >
        {{item}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'date-select',
  props: ['dateData', 'firstItem', 'isActive'],
  components: {
  },
  data() {
    return {
      inputInfo: this.firstItem,
      showContent: false
    }
  },
  computed: {
    selectedDate() {
      return this.inputInfo;
    }
  },
  methods: {
    showOptions() {
      this.showContent = !this.showContent;
    },
    selectOption(info) {
      this.inputInfo = info;
      this.$emit('dateValue', this.inputInfo);
      this.showOptions();
    }
  },
  watch: {
    dateData() {
      if(this.dateData[0]) {
        this.inputInfo = this.dateData[0];
        this.$emit('dateValue', this.inputInfo);
      }
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .date-select{
    position: relative;
    width: 6rem;
    border-bottom: 2px solid #df2860;
    display: flex;
    justify-content: center;
    &__main {
      position: relative;
      font-family: 'Poppins', sans-serif;
      font-size: 2rem;
      width: 5rem;
      height: 2rem;
      display: flex;
      justify-content: center;
    }
    &__arrow {
      border-left: 0.2rem solid transparent;
      border-right: 0.2rem solid transparent;
      border-top: 0.4rem solid #cacaca;
      top: 0;
      right: 0;
    }
    &__arrow-container {
      position: absolute;
      top: 0.3rem;
      right: -1rem;
      cursor: pointer;
      height: 100%;
    }
    &__content {
      font-family: 'Poppins', sans-serif;
      height: 0;
      overflow: hidden;
      transition: 0.5s;
      position: absolute;
      width: 100%;
      width: 130%;
      top: 2.4rem;
      background-color: #fff;
      div {
        cursor: pointer;
        padding: 0.4em 0 0 0;
        display: flex;
        justify-content: center;
      }
    }
    .contentActive {
      height: 6rem;
      overflow-y: scroll;
      transition: 0.5s;
    }
  }
</style>
